import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import {
  VideoSkipabilityOption,
  type VideoSkipabilityPayload,
  type VideoSkipabilityValue,
} from '@openx/types/targeting/video.ts';
import { type JSX, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getOptionKeys, getVideoSkipabilityOptions } from '../../utils/utils.ts';

type Props = {
  placeholder: string;
  onChange: (typeParams: VideoSkipabilityPayload | null) => void;
  value: VideoSkipabilityValue | null;
  label: string;
};

export const VideoSkipabilityDropdown = ({ placeholder, onChange, value, label }: Props): JSX.Element => {
  const { t } = useTranslation();

  const videoOptions = useMemo(() => getVideoSkipabilityOptions(t), [t]);

  const handleChange = useCallback(
    (_e, value) => (value ? onChange({ op: VideoSkipabilityOption.EQUALS, val: value }) : onChange(null)),
    [onChange]
  );

  return (
    <AutoComplete<VideoSkipabilityValue, false, false, false>
      textFieldProps={{ placeholder, label }}
      options={getOptionKeys(videoOptions)}
      fullWidth
      renderOptions={{
        dataTest: 'type-option',
      }}
      getOptionLabel={option => videoOptions[option].name}
      onChange={handleChange}
      value={value}
      textFieldReadOnly
      data-test="video-input"
    />
  );
};
